var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankSlipHaiah(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 405 287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".u{fill:url(#g);}.v{fill:url(#p);}.w{fill:url(#o);}.x{fill:url(#q);}.y{fill:url(#i);}.a`{fill:url(#h);}.aa{fill:url(#k);}.ab{fill:url(#j);}.ac{fill:url(#m);}.ad{fill:url(#l);}.ae{fill:url(#n);}.af,.ag{stroke-width:.82px;}.af,.ag,.ah,.ai,.aj{fill:none;stroke-miterlimit:10;}.af,.ah,.ai,.aj{stroke:#c4c4c4;}.ag{stroke:#575756;}.ak{fill:#ebebeb;}.al{fill:#d8d8d8;}.am{fill:#9b9b9a;}.an{fill:#575756;}.ah{stroke-width:.74px;}.ao{fill:url(#d);filter:url(#e);}.ap{fill:url(#r);filter:url(#s);}.ai{stroke-width:.52px;}.aj{stroke-width:.8px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 203.41,
    y1: 100.32,
    x2: 155.41,
    y2: 275.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ebebeb"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.5,
    dy: 8.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "f",
    stdDeviation: 11.34
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b2b5bb",
    floodOpacity: 0.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "f",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 64.73,
    y1: 50.97,
    x2: 93.26,
    y2: 54.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42cf85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36a9a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 65.02,
    y1: 48.89,
    x2: 93.54,
    y2: 52.85,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 64.68,
    y1: 51.32,
    x2: 93.21,
    y2: 55.28,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 64.74,
    y1: 50.9,
    x2: 93.26,
    y2: 54.86,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 64.79,
    y1: 50.54,
    x2: 93.31,
    y2: 54.51,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 64.92,
    y1: 49.63,
    x2: 93.44,
    y2: 53.6,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 64.87,
    y1: 49.93,
    x2: 93.4,
    y2: 53.89,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 65,
    y1: 49.01,
    x2: 93.53,
    y2: 52.97,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 65.01,
    y1: 48.99,
    x2: 93.53,
    y2: 52.95,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 64.56,
    y1: 52.17,
    x2: 93.09,
    y2: 56.13,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 64.5,
    y1: 52.65,
    x2: 93.02,
    y2: 56.62,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 326.93,
    y1: 64.7,
    x2: 340.21,
    y2: 48.22,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.83,
    dy: 8.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "t",
    stdDeviation: 5.67
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74787f",
    floodOpacity: 0.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "t",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "ak",
    x: 279.43,
    y: 75.75,
    width: 72.94,
    height: 18.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ak",
    x: 279.43,
    y: 113.44,
    width: 72.94,
    height: 18.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ak",
    x: 279.29,
    y: 186.46,
    width: 72.94,
    height: 14.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M356.26,243.83H31.77c-3.45,0-6.25-2.8-6.25-6.25V31.78c0-3.45,2.8-6.25,6.25-6.25H321.16l41.34,41.34V237.58c0,3.45-2.8,6.25-6.25,6.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ah",
    x: 35.66,
    y: 59.21,
    width: 316.72,
    height: 142.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "ag",
    x1: 106.65,
    y1: 43.99,
    x2: 106.65,
    y2: 59.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "ag",
    x1: 137,
    y1: 43.99,
    x2: 137,
    y2: 59.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "ah",
    x1: 279.43,
    y1: 59.55,
    x2: 279.43,
    y2: 201.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "ai",
    x1: 213.03,
    y1: 94.68,
    x2: 213.03,
    y2: 131.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "ai",
    x1: 153.98,
    y1: 94.68,
    x2: 153.98,
    y2: 131.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "ai",
    x1: 94.85,
    y1: 94.68,
    x2: 94.85,
    y2: 131.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "af",
    x1: 352.38,
    y1: 113.61,
    x2: 35.66,
    y2: 113.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "af",
    x1: 352.38,
    y1: 75.75,
    x2: 35.66,
    y2: 75.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 352.38,
    y1: 113.61,
    x2: 279.43,
    y2: 113.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 352.38,
    y1: 150.04,
    x2: 279.43,
    y2: 150.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 352.38,
    y1: 168.25,
    x2: 279.43,
    y2: 168.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 352.38,
    y1: 186.46,
    x2: 279.43,
    y2: 186.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "af",
    x1: 352.38,
    y1: 94.68,
    x2: 35.66,
    y2: 94.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 352.38,
    y1: 131.82,
    x2: 35.66,
    y2: 131.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 98.92,
    y: 64.12,
    width: 171.35,
    height: 5.93,
    rx: 2.97,
    ry: 2.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 38.78,
    y: 64.12,
    width: 47.62,
    height: 5.93,
    rx: 2.97,
    ry: 2.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 37.91,
    y: 77.86,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 281.58,
    y: 79.1,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 281.58,
    y: 134.68,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 281.58,
    y: 154.22,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 281.58,
    y: 171.1,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 281.58,
    y: 191.84,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 281.58,
    y: 86.27,
    width: 67.7,
    height: 3.82,
    rx: 1.91,
    ry: 1.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 281.58,
    y: 60.3,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 313.28,
    y: 67.08,
    width: 36,
    height: 4.87,
    rx: 2.34,
    ry: 2.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 108.84,
    y: 49.73,
    width: 26.31,
    height: 4.87,
    rx: 2.44,
    ry: 2.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 175.47,
    y: 49.73,
    width: 152.63,
    height: 4.87,
    rx: 2.44,
    ry: 2.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 332.35,
    y: 49.73,
    width: 4.87,
    height: 4.87,
    rx: 2.44,
    ry: 2.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 281.58,
    y: 98.02,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 313.28,
    y: 104.8,
    width: 36,
    height: 4.87,
    rx: 2.34,
    ry: 2.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 313.28,
    y: 177.36,
    width: 36,
    height: 4.87,
    rx: 2.34,
    ry: 2.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 313.28,
    y: 227.36,
    width: 36,
    height: 4.87,
    rx: 2.34,
    ry: 2.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 281.58,
    y: 118.15,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 313.28,
    y: 117.84,
    width: 36,
    height: 9.75,
    rx: 4.87,
    ry: 4.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 38.78,
    y: 84.16,
    width: 171.35,
    height: 5.93,
    rx: 2.97,
    ry: 2.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 38.78,
    y: 98.03,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 38.78,
    y: 134.46,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 38.78,
    y: 142.62,
    width: 162.16,
    height: 3.82,
    rx: 1.91,
    ry: 1.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 38.78,
    y: 150.4,
    width: 162.16,
    height: 3.82,
    rx: 1.91,
    ry: 1.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 38.78,
    y: 158.17,
    width: 162.16,
    height: 3.82,
    rx: 1.91,
    ry: 1.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 38.78,
    y: 165.95,
    width: 162.16,
    height: 3.82,
    rx: 1.91,
    ry: 1.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 38.78,
    y: 193.75,
    width: 108,
    height: 3.82,
    rx: 1.91,
    ry: 1.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 38.78,
    y: 104.33,
    width: 53.25,
    height: 5.93,
    rx: 2.97,
    ry: 2.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 97.83,
    y: 98.03,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 97.83,
    y: 104.33,
    width: 53.25,
    height: 5.93,
    rx: 2.97,
    ry: 2.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 156.88,
    y: 98.03,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 156.88,
    y: 104.33,
    width: 53.25,
    height: 5.93,
    rx: 2.97,
    ry: 2.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 215.93,
    y: 98.03,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 215.93,
    y: 104.33,
    width: 53.25,
    height: 5.93,
    rx: 2.97,
    ry: 2.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 38.78,
    y: 116.6,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 38.78,
    y: 122.9,
    width: 53.25,
    height: 5.93,
    rx: 2.97,
    ry: 2.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 97.83,
    y: 116.6,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 97.83,
    y: 122.9,
    width: 32.59,
    height: 5.93,
    rx: 2.97,
    ry: 2.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 156.88,
    y: 116.6,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 184.59,
    y: 122.9,
    width: 25.53,
    height: 5.93,
    rx: 2.97,
    ry: 2.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "am",
    x: 215.93,
    y: 116.6,
    width: 28.28,
    height: 3.82,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "al",
    x: 215.93,
    y: 122.9,
    width: 29,
    height: 5.93,
    rx: 2.97,
    ry: 2.97
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.32,44.58h-7.68l-1.68,3.73h-1.04l6.09-13.25h.97l6.09,13.25h-1.04l-1.7-3.73Zm-.36-.81l-3.48-7.65-3.46,7.65h6.95Zm4.37-8.71h.97v13.25h-.97v-13.25Zm12.64,9.52h-7.68l-1.68,3.73h-1.04l6.09-13.25h.97l6.09,13.25h-1.04l-1.7-3.73Zm-.36-.81l-3.48-7.65-3.46,7.65h6.95Zm-37.79-8.71h-.97v13.25h.97v-13.25Zm8.86,0v6.2h-6.24v.85h6.24v6.2h.97v-13.25h-.97Zm-7.54,6.03c-.33,0-.6,.27-.6,.6s.27,.6,.6,.6,.6-.27,.6-.6-.27-.6-.6-.6Zm50.63,7.22h.97v-13.25h-.97v13.25Zm-8.86,0v-6.2h6.24v-.85h-6.24v-6.2h-.97v13.25h.97Zm7.54-6.03c.33,0,.6-.27,.6-.6s-.27-.6-.6-.6-.6,.27-.6,.6,.27,.6,.6,.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M72.81,51.08v.2h-.51v.58h.51v2.48h.72v-2.48h.82v-.58h-.85v-.18c0-.33,.16-.49,.45-.49,.15,0,.29,.05,.4,.13l.2-.54c-.16-.12-.4-.17-.65-.17-.71,0-1.1,.42-1.1,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M75.32,49.89c-.26,0-.46,.19-.46,.43s.2,.43,.46,.43,.46-.2,.46-.45c0-.24-.2-.41-.46-.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    x: 74.96,
    y: 51.26,
    width: 0.72,
    height: 3.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ab",
    points: "78.69 51.26 77.71 53.53 76.75 51.26 76 51.26 77.32 54.33 78.06 54.33 79.38 51.26 78.69 51.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M80.96,51.22c-.92,0-1.59,.66-1.59,1.57s.67,1.58,1.7,1.58c.53,0,.96-.17,1.24-.5l-.39-.44c-.22,.22-.49,.33-.83,.33-.54,0-.91-.29-1-.74h2.41c0-.07,.01-.16,.01-.21,0-.96-.66-1.59-1.55-1.59Zm-.87,1.32c.07-.45,.41-.75,.87-.75s.81,.31,.87,.75h-1.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    x: 82.98,
    y: 50.06,
    width: 0.72,
    height: 4.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M85.59,51.22c-.49,0-.97,.13-1.3,.38l.28,.52c.23-.19,.59-.31,.93-.31,.51,0,.77,.25,.77,.67v.05h-.79c-.93,0-1.28,.4-1.28,.92s.44,.92,1.15,.92c.46,0,.79-.15,.97-.41v.37h.68v-1.8c0-.89-.51-1.31-1.4-1.31Zm.68,2.15c-.12,.32-.43,.48-.78,.48-.37,0-.59-.17-.59-.43,0-.22,.13-.41,.62-.41h.74v.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M89.26,51.22c-.39,0-.74,.13-.98,.41v-1.57h-.72v4.27h.68v-.4c.24,.29,.6,.44,1.02,.44,.9,0,1.56-.62,1.56-1.58s-.66-1.57-1.56-1.57Zm-.08,2.53c-.52,0-.92-.37-.92-.96s.4-.96,.92-.96,.91,.37,.91,.96-.39,.96-.91,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M91.84,52.15c0-.2,.21-.35,.64-.35,.29,0,.59,.06,.88,.23l.28-.55c-.28-.17-.74-.26-1.15-.26-.83,0-1.35,.38-1.35,.96,0,1.23,1.9,.67,1.9,1.26,0,.21-.19,.34-.64,.34-.39,0-.8-.13-1.07-.31l-.28,.55c.28,.2,.79,.35,1.3,.35,.86,0,1.39-.37,1.39-.95,0-1.2-1.9-.65-1.9-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M66.17,51.25c-.39,0-.73,.13-.97,.4v-1.55h-.71v4.23h.68v-.39c.24,.29,.59,.43,1.01,.43,.89,0,1.54-.62,1.54-1.56s-.65-1.55-1.54-1.55Zm-.08,2.51c-.51,0-.91-.37-.91-.95s.39-.95,.91-.95,.9,.37,.9,.95-.39,.95-.9,.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M69.4,53.53l-.96-2.25h-.74l1.33,3.05-.05,.12c-.14,.3-.28,.42-.54,.42-.19,0-.39-.08-.52-.21l-.28,.52c.19,.18,.51,.28,.81,.28,.51,0,.89-.21,1.17-.9l1.42-3.29h-.68l-.96,2.25Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 233.41,
    y: 207.39,
    width: 5.8,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 229.63,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 194.52,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 221.28,
    y: 207.39,
    width: 3.47,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 226.16,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 184.69,
    y: 207.39,
    width: 5.8,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 180.91,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 172.57,
    y: 207.39,
    width: 3.47,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 177.45,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 212.34,
    y: 207.39,
    width: 5.8,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 208.56,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 191.54,
    y: 207.39,
    width: 0.78,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 200.21,
    y: 207.39,
    width: 3.47,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 205.09,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 164.95,
    y: 207.39,
    width: 5.8,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 161.17,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 126.06,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 152.83,
    y: 207.39,
    width: 3.47,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 157.71,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 116.24,
    y: 207.39,
    width: 5.8,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 112.46,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 104.11,
    y: 207.39,
    width: 3.47,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 108.99,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 143.88,
    y: 207.39,
    width: 5.8,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 140.1,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 123.08,
    y: 207.39,
    width: 0.78,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 131.75,
    y: 207.39,
    width: 3.47,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 136.63,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 96.49,
    y: 207.39,
    width: 5.8,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 92.71,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 57.6,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 84.37,
    y: 207.39,
    width: 3.47,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 89.25,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 47.78,
    y: 207.39,
    width: 5.8,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 44,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 35.66,
    y: 207.39,
    width: 3.47,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 40.54,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 75.42,
    y: 207.39,
    width: 5.8,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 71.64,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 54.62,
    y: 207.39,
    width: 0.78,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 63.3,
    y: 207.39,
    width: 3.47,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "an",
    x: 68.18,
    y: 207.39,
    width: 1.56,
    height: 24.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M362.51,66.88h-35.15c-3.42,0-6.2-2.77-6.2-6.2V25.53l41.34,41.34Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSlipHaiah);
export default __webpack_public_path__ + "static/media/bank-slip-haiah.e749d81d1b631e49a49b8ffae153d77f.svg";
export { ForwardRef as ReactComponent };